import { action, observable, makeObservable } from 'mobx';
import { exchangeAmountByRate, maskName } from '@pascal/pascal-core';

class LiveBetsDataStore {
  liveBets = [];

  constructor() {
    makeObservable(this, {
      liveBets: observable.deep,
      updateLiveBets: action.bound,
    });
  }

  setLiveBets(liveBets) {
    this.liveBets = liveBets.map((liveBet) => ({
      userId: maskName(liveBet.userId),
      id: liveBet.id,
      odd: liveBet.odd,
      ...exchangeAmountByRate(liveBet),
    }));
  }

  updateLiveBets(liveBet) {
    const result = {
      userId: maskName(liveBet.userId),
      id: liveBet.id,
      odd: liveBet.odd,
      ...exchangeAmountByRate(liveBet),
    };
    if (this.liveBets.length === 30) {
      this.liveBets = [result, ...this.liveBets];
      this.liveBets.pop();
    } else {
      this.liveBets = [result, ...this.liveBets];
    }
  }

  resetLiveBetsData(data) {
    this.liveBets = data;
  }
}

export const liveBetsDataStore = new LiveBetsDataStore();
